import { initializeApp, getApps, getApp, FirebaseApp } from 'firebase/app'

export function getFirebaseApp(config?: any): FirebaseApp {
  return getApps().length ? getApp() : initializeApp(config)
}
